// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1azSL","questions":"styles_questions__1-2hs","footer":"styles_footer__1MArK"};